// extracted by mini-css-extract-plugin
export default {"item":"ListItem_item__G8oV1","name":"ListItem_name__EO4Hb","value":"ListItem_value__PUs2j","ellipsis":"ListItem_ellipsis__MX7Ux"};